@import "../../helpers/ScreenSizes";

:host {
  display: block;
}

.consumerInfoForm {
  display: grid;
  gap: 16px;
}

.nameFields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @include small() {
    grid-template-columns: minmax(0, 1fr);
  }
}

.contactFields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @include medium() {
    grid-template-columns: minmax(0, 1fr);
  }
}
